__turbopack_context__.v({
  "shippingText": "yvfvhG_shippingText",
  "submitButton": "yvfvhG_submitButton",
  "timeWrapper": "yvfvhG_timeWrapper",
});
